/* pn-productos-nav-v2 */
(function() {
  var SLUG_ALIASES = {
    'telas-impermeables-y-de-confeccion': 'telas-impermeables-y-confeccion',
    'telas-y-cuerinas-para-tapiceria': 'telas-y-cuerinas-para-tapiceria',
    'pisos-alfombras-y-gramas': 'pisos-alfombras-y-gramas',
    'construccion-cerramientos-y-agro': 'construccion-cerramientos-y-agro',
    'lonas-y-cubrimientos': 'lonas-y-cubrimientos',
    'espumas-y-guatas': 'espumas-y-guatas',
    'pegamentos-y-adhesivos': 'pegamentos-y-adhesivos',
    'empaque-y-embalaje': 'empaque-y-embalaje',
    'complementos-y-herramientas': 'complementos-y-herramientas',
    'colchones-descanso-y-hogar': 'colchones-descanso-y-hogar',
    'marroquineria-y-calzado': 'marroquineria-y-calzado'
  };

  var CATEGORY_IMAGE_OVERRIDES = {
    'telas-y-cuerinas-para-tapiceria': {
      'tapiceria-institucional-y-hogar': 'https://plastinorte.myshopify.com/cdn/shop/files/Tapiceria_1.png?width=800',
      'tapiceria-automotriz': 'https://plastinorte.myshopify.com/cdn/shop/files/Tapiceria_2.png?width=800',
      'tapiceria-exterior': 'https://plastinorte.myshopify.com/cdn/shop/files/Tapiceria_3.png?width=800',
      'tapiceria-nautica': 'https://plastinorte.myshopify.com/cdn/shop/files/Tapiceria_4.png?width=800'
    },
    'telas-impermeables-y-confeccion': {
      'vestuario-y-dotaciones': 'https://plastinorte.myshopify.com/cdn/shop/t/21/assets/sub-impermeables-vestuario-dotaciones.png?width=800&height=460&crop=center',
      'forros-y-cubrimientos': 'https://plastinorte.myshopify.com/cdn/shop/t/21/assets/sub-impermeables-forros-cubrimientos.png?width=800&height=460&crop=center',
      'papel-encuadernacion': 'https://plastinorte.myshopify.com/cdn/shop/t/21/assets/sub-impermeables-papel-encuadernacion.png?width=800&height=460&crop=center',
      'vinilos-transparentes-y-aislantes': 'https://plastinorte.myshopify.com/cdn/shop/t/21/assets/sub-impermeables-vinilos-transparentes-aislantes.png?width=800&height=460&crop=center'
    },
    'construccion-cerramientos-y-agro': {
      'plasticos-y-polietilenos': 'https://plastinorte.myshopify.com/cdn/shop/t/21/assets/sub-construccion-plasticos-polietilenos.png?width=800&height=460&crop=center',
      'mallas-y-cerramientos': 'https://plastinorte.myshopify.com/cdn/shop/t/21/assets/sub-construccion-mallas-cerramientos.png?width=800&height=460&crop=center',
      'polisombras-y-geomembranas': 'https://plastinorte.myshopify.com/cdn/shop/t/21/assets/sub-construccion-polisombras-geomembranas.png?width=800&height=460&crop=center',
      'cuerdas-sogas-y-amarres': 'https://plastinorte.myshopify.com/cdn/shop/t/21/assets/sub-construccion-cuerdas-sogas-amarres.png?width=800&height=460&crop=center',
      'cuerdas-y-sogas': 'https://plastinorte.myshopify.com/cdn/shop/t/21/assets/sub-construccion-cuerdas-sogas-amarres.png?width=800&height=460&crop=center',
      'cintas-y-demarcacion': 'https://plastinorte.myshopify.com/cdn/shop/t/21/assets/sub-construccion-cintas-demarcacion.png?width=800&height=460&crop=center'
    },
    'pisos-alfombras-y-gramas': {
      'pisos-vinilicos-y-caucho': 'https://plastinorte.myshopify.com/cdn/shop/files/Pisos_vinilicos_y_caucho.png?width=800&height=460&crop=center',
      'alfombras-y-tapetes': 'https://plastinorte.myshopify.com/cdn/shop/files/Alfombras_y_Tapetes.png?width=800&height=460&crop=center',
      'gramas-sinteticas': 'https://plastinorte.myshopify.com/cdn/shop/files/Gramas_sinteticas.png?width=800&height=460&crop=center',
      'complementos-y-adhesivos': 'https://plastinorte.myshopify.com/cdn/shop/files/Complementos_y_Adhesivos.png?width=800&height=460&crop=center'
    },
    'espumas-y-guatas': {
      'espuma-de-poliuretano': 'https://plastinorte.myshopify.com/cdn/shop/files/espuma_rosada.png?width=800&height=460&crop=center',
      'espuma-de-polietileno': 'https://plastinorte.myshopify.com/cdn/shop/files/espuma_plateada.png?width=800&height=460&crop=center',
      'espuma-eva': 'https://plastinorte.myshopify.com/cdn/shop/files/espuma_eva.png?width=800&height=460&crop=center',
      'guatas-rellenos-y-fieltros': 'https://plastinorte.myshopify.com/cdn/shop/files/guata.png?width=800&height=460&crop=center',
      'moldeados-para-vehiculos': 'https://plastinorte.myshopify.com/cdn/shop/t/21/assets/sub-espumas-moldeados-para-vehiculos.png?v=16930517807121792691782488026&width=800&height=460&crop=center',
      'espumas-moldeadas-para-vehiculos': 'https://plastinorte.myshopify.com/cdn/shop/t/21/assets/sub-espumas-moldeados-para-vehiculos.png?v=16930517807121792691782488026&width=800&height=460&crop=center',
      'espuma-cassata': 'https://plastinorte.myshopify.com/cdn/shop/files/Espuma_Cassata.png?width=800&height=460&crop=center',
      'espuma-troquelada': 'https://plastinorte.myshopify.com/cdn/shop/files/Espuma_troquelada.png?width=800&height=460&crop=center',
      'espuma-para-bondeo': 'https://plastinorte.myshopify.com/cdn/shop/files/Espuma_para_Bondeo.png?width=800&height=460&crop=center'
    },
    'pegamentos-y-adhesivos': {
      'pegantes-y-adhesivos-para-tapiceria': 'https://plastinorte.myshopify.com/cdn/shop/files/Adhesivos_industriales.png?width=800&height=460&crop=center',
      'pegantes-y-adhesivos-para-madera': 'https://plastinorte.myshopify.com/cdn/shop/files/Adhesivos_para_madera.png?width=800&height=460&crop=center',
      'pegantes-y-adhesivos-para-construccion': 'https://plastinorte.myshopify.com/cdn/shop/t/21/assets/pegantes-adhesivos-construccion.png?width=800&height=460&crop=center'
    },
    'empaque-y-embalaje': {
      'cartones': 'https://plastinorte.myshopify.com/cdn/shop/files/carton.png?width=800&height=460&crop=center',
      'plastico-burbuja-y-polietileno': 'https://plastinorte.myshopify.com/cdn/shop/files/plasticop.png?width=800&height=460&crop=center',
      'espuma-de-proteccion': 'https://plastinorte.myshopify.com/cdn/shop/files/espumasr.png?width=800&height=460&crop=center',
      'plastico-strech': 'https://plastinorte.myshopify.com/cdn/shop/files/plasticostr.png?width=800&height=460&crop=center',
      'amarres-y-cuerdas': 'https://plastinorte.myshopify.com/cdn/shop/files/Amarres_y_Cuerdas.png?width=800&height=460&crop=center',
      'cintas-adhesivas': 'https://plastinorte.myshopify.com/cdn/shop/files/Cintas_Adhesivas.png?width=800&height=460&crop=center'
    },
    'complementos-y-herramientas': {
      'grapas-y-clavillos': 'https://plastinorte.myshopify.com/cdn/shop/files/Grapas_y_Clavillos.png?width=800&height=460&crop=center',
      'grapadoras-y-herramientas': 'https://plastinorte.myshopify.com/cdn/shop/files/Grapadoras_y_Herramientas.png?width=800&height=460&crop=center',
      'cinchas-reatas-y-resortes': 'https://plastinorte.myshopify.com/cdn/shop/files/Cinchas_Reatas_y_Resortes.png?width=800&height=460&crop=center',
      'velcros-y-cremalleras': 'https://plastinorte.myshopify.com/cdn/shop/files/Velcros_y_Cremalleras.png?width=800&height=460&crop=center',
      'hilos': 'https://plastinorte.myshopify.com/cdn/shop/files/Hilos.png?width=800&height=460&crop=center',
      'herrajes': 'https://plastinorte.myshopify.com/cdn/shop/files/Herrajes.jpg?width=800&height=460&crop=center'
    },
    'colchones-descanso-y-hogar': {
      'colchones-y-colchonetas': 'https://plastinorte.myshopify.com/cdn/shop/files/Colchones_y_Colchonetas_7544b2c9-5a5d-4f31-b06b-6e3b29b0a265.png?width=800&height=460&crop=center',
      'base-camas-y-cabeceros': 'https://plastinorte.myshopify.com/cdn/shop/files/Basecamas_y_Cabeceros.png?width=800&height=460&crop=center',
      'sofas-sofacamas-y-poltronas': 'https://plastinorte.myshopify.com/cdn/shop/files/Sofas_Sofacamas_y_Poltronas.png?width=800&height=460&crop=center',
      'almohadas-y-cojines': 'https://plastinorte.myshopify.com/cdn/shop/files/Almohadas_y_cojines.png?width=800&height=460&crop=center',
      'tapetes-y-alfombras': 'https://plastinorte.myshopify.com/cdn/shop/files/Tapetes_y_alfombras.png?width=800&height=460&crop=center',
      'mobiliario-para-exteriores': 'https://plastinorte.myshopify.com/cdn/shop/files/Mobiliario_para_exteriores.png?width=800&height=460&crop=center',
      'sabanas-protectores-y-edredones': 'https://plastinorte.myshopify.com/cdn/shop/t/21/assets/colchones-sabanas-protectores-edredones.jpg?width=800&height=460&crop=center',
      'manteles-plasticos': 'https://plastinorte.myshopify.com/cdn/shop/t/21/assets/colchones-manteles-plasticos.jpg?width=800&height=460&crop=center'
    },
    'marroquineria-y-calzado': {
      'plantillas-y-complementos': 'https://plastinorte.myshopify.com/cdn/shop/t/21/assets/sub-marroquineria-plantillas-y-complementos.png?v=54472860212124946801782487435&width=800',
      'telas-para-marroquineria': 'https://plastinorte.myshopify.com/cdn/shop/t/21/assets/sub-marroquineria-telas-para-marroquineria.png?v=150868496578123818511782487440&width=800'
    }
  };

  var CATEGORY_COPY_OVERRIDES = {
    'lonas-y-cubrimientos': {
      'carpas-toldos-y-parasoles': {
        title: 'Carpas, toldos y parasoles',
        phrase: 'Descubre la variedad de materiales que ofrecemos en nuestro catalogo'
      },
      'camion-y-carga-pesada': {
        title: 'Camion y carga pesada',
        phrase: 'Encuentra soluciones para proteger y delimitar espacios.'
      },
      'inflables-y-recreacion': {
        title: 'Inflables y recreación',
        phrase: 'Encuentra la solución que tu proyecto necesita'
      },
      'vinilos-transparentes-y-aislantes': {
        title: 'Vinilos transparentes y aislantes',
        phrase: 'Explora productos para cada tipo de aplicación.'
      }
    },
    'construccion-cerramientos-y-agro': {
      'plasticos-y-polietilenos': {
        title: 'Plasticos y Polietilenos',
        phrase: 'Descubre materiales impermeables para proteger, aislar y cubrir'
      },
      'mallas-y-cerramientos': {
        title: 'Mallas y cerramientos',
        phrase: 'Encuentra soluciones para proteger y delimitar espacios.'
      },
      'polisombras-y-geomembranas': {
        title: 'Polisombras y geomembranas',
        phrase: 'Encuentra la solución que tu proyecto necesita'
      },
      'cuerdas-sogas-y-amarres': {
        title: 'Cuerdas, sogas y amarres',
        phrase: 'Explora productos para cada tipo de aplicación.'
      },
      'cuerdas-y-sogas': {
        title: 'Cuerdas, sogas y amarres',
        phrase: 'Explora productos para cada tipo de aplicación.'
      },
      'cintas-y-demarcacion': {
        title: 'Cintas y demarcación',
        phrase: 'Conoce opciones para señalizar y organizar mejor'
      }
    },
    'telas-impermeables-y-confeccion': {
      'vestuario-y-dotaciones': {
        title: 'Vestuario y dotaciones',
        phrase: 'Explora materiales para cada proyecto'
      },
      'forros-y-cubrimientos': {
        title: 'Forros y cubrimientos',
        phrase: 'Conoce materiales para proteger y cubrir'
      },
      'papel-encuadernacion': {
        title: 'Papel encuadernación',
        phrase: 'Encuentra variedad en nuestro catálogo'
      },
      'vinilos-transparentes-y-aislantes': {
        title: 'Vinilos transparentes y aislantes',
        phrase: 'Descubre materiales impermeables para proteger, aislar y cubrir'
      }
    },
    'telas-y-cuerinas-para-tapiceria': {
      'tapiceria-institucional-y-hogar': {
        phrase: 'Explora nuestras opciones de telas para renovar tus espacios con estilo y calidad.'
      },
      'tapiceria-automotriz': {
        phrase: 'Descubre nuestras telas para personalizar tu vehículo y hacerlo único.'
      },
      'tapiceria-exterior': {
        phrase: 'Ideal para tus proyectos al aire libre, con máxima resistencia y diseño elegante.'
      },
      'tapiceria-nautica': {
        phrase: 'Perfecta para ambientes marinos, diseñada para durar incluso en las condiciones más difíciles.'
      }
    },
    'pisos-alfombras-y-gramas': {
      'pisos-vinilicos-y-caucho': {
        phrase: 'Resistentes, versátiles y fáciles de mantener. Encuentra la solución ideal para cada espacio.'
      },
      'alfombras-y-tapetes': {
        phrase: 'Estilo y confort en cada paso. Diseños y texturas que transforman tus ambientes.'
      },
      'gramas-sinteticas': {
        phrase: 'Verde perfecto todo el año. Ideal para interiores, exteriores y proyectos deportivos.'
      },
      'complementos-y-adhesivos': {
        phrase: 'Todo lo que necesitas para una instalación segura y duradera. ¡Hazlo fácil y efectivo!'
      }
    },
    'espumas-y-guatas': {
      'espuma-de-poliuretano': {
        phrase: 'Versatilidad y confort para múltiples aplicaciones.'
      },
      'espuma-de-polietileno': {
        phrase: 'Ligera, ideal para proporcionar protección, aislamiento contra la humedad y térmico, así como para la absorción de impactos.'
      },
      'espuma-eva': {
        phrase: 'Flexible, duradera y perfecta para aplicaciones creativas e industriales.'
      },
      'guatas-rellenos-y-fieltros': {
        phrase: 'Acolchado, volumen y confort con alta calidad.'
      },
      'moldeados-para-vehiculos': {
        phrase: 'Moldes de poliuretano, como respaldos, cabeceros y asientos de alta calidad. ¡Explora los modelos!'
      },
      'espumas-moldeadas-para-vehiculos': {
        phrase: 'Moldes de poliuretano, como respaldos, cabeceros y asientos de alta calidad. ¡Explora los modelos!'
      },
      'espuma-cassata': {
        phrase: 'Resistencia, estabilidad y soporte en densidades medias y altas. Conócela aquí!'
      },
      'espuma-troquelada': {
        phrase: 'Material versátil que ofrece protección y comodidad en diversas industrias. ¡Descubre más aquí!'
      },
      'espuma-para-bondeo': {
        phrase: 'Ideal para procesos de laminado, proyectos de tapicería y confección. Conoce más!'
      }
    },
    'marroquineria-y-calzado': {
      'plantillas-y-complementos': {
        phrase: '¿Diseña, crea y perfecciona cada pieza con nuestros complementos.'
      },
      'telas-para-marroquineria': {
        phrase: 'Telas de alta calidad para crear piezas únicas y duraderas.'
      }
    },
    'pegamentos-y-adhesivos': {
      'para-tapiceria': {
        phrase: 'Adhesivos industriales especializados: ¡descúbrelos aquí!'
      },
      'para-madera': {
        phrase: 'Ideal para protección, aislamiento de humedad y térmico en diversos proyectos.'
      },
      'para-construccion': {
        phrase: 'Adhesión fuerte y confiable en múltiples superficies. ¡descúbrelo aquí!'
      },
      'cintas-adhesivas': {
        phrase: 'Fijación segura y resistente para cada proyecto. ¡Descúbrelas aquí!'
      }
    },
    'empaque-y-embalaje': {
      'cartones': {
        phrase: 'Cartones para embalaje y protección. Míralos y explora todas las referencias aquí.'
      },
      'plastico-burbuja-y-polietileno': {
        phrase: 'Ligero, ideal para proporcionar protección, aislamiento contra la humedad y térmico, así como para la absorción de impactos. ¡Descúbrela aquí!'
      },
      'espuma-de-proteccion': {
        phrase: 'Ligera y perfecta para protección, aislamiento contra humedad y calor, así como para absorber impactos. ¡Descúbrela aquí!'
      },
      'plastico-strech': {
        phrase: 'Plástico de diferentes anchos para envolver y proteger productos en almacenamiento o transporte. ¡Descúbrela aquí!'
      },
      'cuerdas-sogas-y-amarres': {
        phrase: '¡Cuerdas y amarres para empacar y embalar, con mil y un usos! ¡Explora todas las opciones!'
      },
      'cintas-adhesivas': {
        phrase: 'Cintas adhesivas para empaque y embalaje de alta calidad. Descubre aquí todas las referencias.'
      }
    },
    'complementos-y-herramientas': {
      'grapas-y-clavillos': {
        phrase: 'Piezas clave en la tapicería, conectando y fijando cada detalle. ¡Sumérgete en la variedad, explora y déjate inspirar!'
      },
      'grapadoras-y-herramientas': {
        phrase: 'Herramientas perfectas para convertir tu trabajo en una obra maestra de eficiencia y profesionalismo. ¡Échales un vistazo aquí!'
      },
      'cinchas-reatas-y-resortes': {
        phrase: 'Elementos que proporcionan soporte, elasticidad y confort a tus muebles. ¡Descúbrelos aquí!'
      },
      'velcros-y-cremalleras': {
        phrase: 'Productos que aportan acabado y funcionalidad a tus creaciones y al producto final. ¡Descúbrelos aquí!'
      },
      'hilos': {
        phrase: 'Dale vida a tus proyectos con nuestra amplia gama y variedad de colores de hilos industriales. ¡Entra y explora!'
      },
      'herrajes': {
        phrase: 'Dale un toque único y acabados de calidad a tus proyectos de tapicería ¡Descubre aquí todas las referencias!'
      }
    },
    'colchones-descanso-y-hogar': {
      'colchones-y-colchonetas': {
        phrase: '¿Buscas un colchón o colchoneta que se ajuste a tus necesidades para un descanso excepcional y cómodo? ¡Aquí lo tienes!'
      },
      'base-camas-y-cabeceros': {
        phrase: '¡Descubre tapizados y telas fabulosas que darán estilo a tu dormitorio! ¡Explora nuestros irresistibles diseños!'
      },
      'sofas-sofacamas-y-poltronas': {
        phrase: 'Mobiliario cómodo, atractivo y con estilo para disfrutar en tu hogar. ¡Descúbrelos aquí!'
      },
      'almohadas-y-cojines': {
        phrase: '¡Disfruta de descanso y comodidad con glamour! Transforma tu espacio en un acogedor paraíso chic con nuestras almohadas y cojines. ¡Descubre su encanto!'
      },
      'sabanas-protectores-y-edredones': {
        phrase: 'Confort, suavidad y protección para cada noche. Encuentra sábanas, protectores y edredones ideales para tu hogar. ¡Descúbrelos aquí!'
      },
      'manteles-plasticos': {
        phrase: 'Manteles plásticos ideales para el hogar, eventos y negocios, con la resistencia que necesitas. ¡Descúbrelos aquí!'
      },
      'tapetes-y-alfombras': {
        phrase: '¡Añade chispa a tus espacios y hazlos cálidos con nuestros fabulosos tapetes y alfombras! ¡Explora todas las opciones aquí!'
      },
      'mobiliario-para-exteriores': {
        phrase: '¡Descubre nuestros exclusivos diseños de mobiliario exterior! Añaden estilo y funcionalidad a tus espacios. ¡Explóralos ya!'
      }
    }
  };

  function getSubImageOverride(categorySlug, title) {
    var map = CATEGORY_IMAGE_OVERRIDES[categorySlug];
    if (!map) return '';
    return map[slugifyMenuTitle(title)] || '';
  }

  function getSubCopyOverride(categorySlug, title) {
    var map = CATEGORY_COPY_OVERRIDES[categorySlug];
    if (!map) return null;
    return map[slugifyMenuTitle(title)] || null;
  }

  function normalizeSlug(slug) {
    return SLUG_ALIASES[slug] || slug;
  }

  function slugifyMenuTitle(text) {
    return text
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function buildProductosSubUrl(slug) {
    var normalized = normalizeSlug(slug);
    return '/collections/all?sub=' + encodeURIComponent(normalized) + '#sub-' + normalized;
  }

  function getProductosCardHref(subLink) {
    var slug = subLink.getAttribute('data-productos-slug');
    if (!slug) {
      var linkText = '';
      subLink.childNodes.forEach(function(node) {
        if (node.nodeType === 3) {
          linkText += node.textContent;
        }
      });
      slug = slugifyMenuTitle(linkText);
    }
    return buildProductosSubUrl(slug);
  }

  function goToProductosCategory(subLink) {
    window.location.href = getProductosCardHref(subLink);
  }

  function getSlugFromLocation() {
    var hash = window.location.hash || '';
    if (hash.indexOf('#sub-') === 0) {
      return normalizeSlug(hash.replace('#sub-', ''));
    }
    if (hash.indexOf('#cat-') === 0) {
      return normalizeSlug(hash.replace('#cat-', ''));
    }
    var params = new URLSearchParams(window.location.search);
    var querySlug = params.get('sub');
    if (querySlug) {
      return normalizeSlug(querySlug);
    }
    return '';
  }

  function clearHideMainStyle() {
    var hideStyle = document.getElementById('productos-hide-main-cards');
    if (hideStyle) hideStyle.remove();
  }

  function setHideMainStyle() {
    if (document.getElementById('productos-hide-main-cards')) return;
    var style = document.createElement('style');
    style.id = 'productos-hide-main-cards';
    style.textContent = '#productos-main-cards{display:none!important}';
    document.head.appendChild(style);
  }

  function hideAllSubPanels() {
    document.querySelectorAll('.productos-sub-panel').forEach(function(panel) {
      panel.hidden = true;
    });
  }

  function getMainCards() {
    return document.getElementById('productos-main-cards') ||
      document.querySelector('.pn-categorias-page:not(#productos-subcategorias-root)');
  }

  function showMainCards() {
    clearHideMainStyle();
    hideAllSubPanels();
    var main = getMainCards();
    if (main) main.hidden = false;
    var subRoot = document.getElementById('productos-subcategorias-root');
    if (subRoot) subRoot.hidden = true;
  }

  function patchPanelImages(panel, categorySlug) {
    if (!panel) return;

    var map = CATEGORY_IMAGE_OVERRIDES[categorySlug];
    if (!map) return;

    var patchKey = 'imagesPatched-' + categorySlug;
    if (panel.dataset[patchKey] === 'true') return;

    Object.keys(map).forEach(function(key) {
      var card = panel.querySelector('#sub-' + key);
      if (!card) return;

      var link = card.querySelector('a');
      if (!link) return;

      var imageSrc = map[key];
      var img = link.querySelector('img');
      if (img) {
        img.src = imageSrc;
        return;
      }

      var placeholder = link.querySelector('.category__placeholder');
      if (placeholder) {
        var alt = placeholder.textContent || '';
        link.innerHTML =
          '<img src="' + imageSrc + '" alt="' + alt.replace(/"/g, '&quot;') + '" loading="lazy" width="400" height="230">';
      }
    });

    panel.dataset[patchKey] = 'true';
  }

  function patchPanelCopy(panel, categorySlug) {
    if (!panel) return;

    var map = CATEGORY_COPY_OVERRIDES[categorySlug];
    if (!map) return;

    var patchKey = 'copyPatched-' + categorySlug;
    if (panel.dataset[patchKey] === 'true') return;

    Object.keys(map).forEach(function(key) {
      var card = panel.querySelector('#sub-' + key);
      if (!card) return;

      var copy = map[key];
      var titleEl = card.querySelector('.category-title');
      var phraseLink = card.querySelector('.category-phrase a');
      if (titleEl && copy.title) titleEl.textContent = copy.title;
      if (phraseLink && copy.phrase) phraseLink.textContent = copy.phrase;
    });

    panel.dataset[patchKey] = 'true';
  }

  function showSubPanel(slug) {
    var panel = document.getElementById('productos-sub-panel-' + slug);
    if (!panel) return false;

    if (CATEGORY_IMAGE_OVERRIDES[slug]) {
      patchPanelImages(panel, slug);
    }

    if (CATEGORY_COPY_OVERRIDES[slug]) {
      patchPanelCopy(panel, slug);
    }

    setHideMainStyle();
    var main = getMainCards();
    if (main) main.hidden = true;
    hideAllSubPanels();
    panel.hidden = false;

    var subRoot = document.getElementById('productos-subcategorias-root');
    if (subRoot) subRoot.hidden = true;

    var title = panel.querySelector('h1');
    if (title) {
      document.title = title.textContent + ' – plastinorte';
    }
    return true;
  }

  function renderSubcategoriesFromJson(slug) {
    var dataEl = document.getElementById('productos-menu-data');
    var subRoot = document.getElementById('productos-subcategorias-root');
    if (!dataEl || !subRoot) return false;

    var menuData;
    try {
      menuData = JSON.parse(dataEl.textContent);
    } catch (e) {
      return false;
    }

    var category = (menuData.categories || []).find(function(item) {
      return item.slug === slug || normalizeSlug(item.slug) === slug;
    });

    if (!category) return false;

    var titleEl = document.getElementById('productos-subcategorias-title');
    var gridEl = document.getElementById('productos-subcategorias-grid');
    if (!titleEl || !gridEl) return false;

    setHideMainStyle();
    var main = getMainCards();
    if (main) main.hidden = true;
    hideAllSubPanels();

    subRoot.hidden = false;
    titleEl.textContent = category.title;
    gridEl.innerHTML = '';

    (category.subs || []).forEach(function(sub) {
      var card = document.createElement('div');
      card.className = 'category';

      var copyOverride = getSubCopyOverride(slug, sub.title);
      var cardTitle = copyOverride && copyOverride.title ? copyOverride.title : sub.title;
      var cardPhrase = copyOverride && copyOverride.phrase ? copyOverride.phrase : 'Explorar subcategoría';

      var imageSrc = getSubImageOverride(slug, sub.title) || sub.image || '';
      if (imageSrc.indexOf('//') === 0) {
        imageSrc = 'https:' + imageSrc;
      }

      var mediaHtml = imageSrc
        ? '<img src="' + imageSrc + '" alt="' + cardTitle.replace(/"/g, '&quot;') + '" loading="lazy" width="400" height="230">'
        : '<div class="category__placeholder">' + cardTitle + '</div>';

      card.innerHTML =
        '<a href="' + sub.url + '">' + mediaHtml + '</a>' +
        '<div class="category-content">' +
          '<div class="category-title">' + cardTitle + '</div>' +
          '<div class="category-phrase"><a href="' + sub.url + '">' + cardPhrase + '</a></div>' +
        '</div>';

      gridEl.appendChild(card);
    });

    document.title = category.title + ' – plastinorte';
    return true;
  }

  function syncProductosSubLocation(slug) {
    if (!slug || !isProductosAllPage()) return;

    var desiredUrl = buildProductosSubUrl(slug);
    var currentUrl = window.location.pathname + window.location.search + window.location.hash;

    if (currentUrl !== desiredUrl) {
      window.history.replaceState(null, '', desiredUrl);
    }
  }

  function isProductosAllPage() {
    return /\/collections\/all\/?$/.test(window.location.pathname);
  }

  function applyProductosSubView() {
    if (!isProductosAllPage()) return;

    if (typeof window.applyProductosSubViewCore === 'function') {
      window.applyProductosSubViewCore();
    }

    var slug = getSlugFromLocation();
    if (!slug) {
      if (typeof window.applyProductosSubViewCore !== 'function') {
        showMainCards();
      }
      return;
    }

    if (showSubPanel(slug) || renderSubcategoriesFromJson(slug)) {
      syncProductosSubLocation(slug);
      return;
    }

    if (typeof window.applyProductosSubViewCore !== 'function') {
      showMainCards();
    }
  }

  function scheduleProductosSubView() {
    applyProductosSubView();

    if (!isProductosAllPage() || !getSlugFromLocation()) return;

    var visiblePanel = document.querySelector('.productos-sub-panel:not([hidden])');
    if (!visiblePanel) {
      if (typeof window.applyProductosSubViewCore === 'function') {
        window.applyProductosSubViewCore();
      }
      requestAnimationFrame(applyProductosSubView);
      window.setTimeout(applyProductosSubView, 0);
      window.setTimeout(applyProductosSubView, 100);
      window.setTimeout(applyProductosSubView, 300);
    }
  }

  window.ProductosNavApply = scheduleProductosSubView;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleProductosSubView);
  } else {
    scheduleProductosSubView();
  }

  window.addEventListener('load', scheduleProductosSubView);
  window.addEventListener('hashchange', scheduleProductosSubView);
  window.addEventListener('pageshow', scheduleProductosSubView);

  var lastTopClicked = null;
  var lastSubClicked = null;

  document.addEventListener('dblclick', function(e) {
    var subLink = e.target.closest('.nav-dropdown__link[data-productos-card]');
    if (!subLink) return;
    e.preventDefault();
    e.stopPropagation();
    goToProductosCategory(subLink);
  });

  document.addEventListener('click', function(e) {
    var topLink = e.target.closest('.nav-bar__link[aria-haspopup="true"]');
    if (topLink) {
      var topHref = topLink.getAttribute('href');
      if (lastTopClicked === topLink && topLink.getAttribute('aria-expanded') === 'true') {
        if (topHref && topHref !== '#' && topHref !== '') {
          window.location.href = topHref;
        }
        return;
      }
      lastTopClicked = topLink;
      lastSubClicked = null;
      return;
    }

    var subLink = e.target.closest('.nav-dropdown__link[data-productos-card]');
    if (subLink) {
      if (subLink.hasAttribute('aria-haspopup')) {
        if (lastSubClicked === subLink && subLink.getAttribute('aria-expanded') === 'true') {
          goToProductosCategory(subLink);
        } else {
          lastSubClicked = subLink;
        }
      } else if (lastSubClicked === subLink) {
        goToProductosCategory(subLink);
        lastSubClicked = null;
      } else {
        lastSubClicked = subLink;
        e.preventDefault();
      }
      return;
    }

    lastTopClicked = null;
    lastSubClicked = null;
  });
})();
